import React from 'react'
import { List, Term, Description, Container } from './styles'
import { Color } from '../../config/theme'

interface Props {
  big?: boolean
  items: {
    term: string
    description: string | number
    color?: Color
  }[]
}

const DescriptionList: React.FC<Props> = ({ big = false, items }) => {
  return (
    <List>
      {items.map((item, i) => (
        <Container
          big={big}
          key={i}
        >
          <Term>
            {item.term}:
          </Term>
          <Description
            color={item.color}
          >
            {item.description}
          </Description>
        </Container>
      ))}
    </List>
  )
}

export default DescriptionList
